var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { color } from "../templates/ui";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";
import InputLabel from "./InputLabel";
import { firstError } from "../../Services/Form";
import Loader from "./icons/Loader";
import SearchButton from "../molecules/SearchButton";
import { getAppThemeName } from "../../Services/appTheme";
const StyledInputWrapper = styled.div `
    position: relative;
    max-width: 100%;
    width: ${(props) => {
    if (props.fullWidth) {
        return "100%";
    }
    return "350px";
}};

    ${(props) => props.hasSearchButton &&
    css `
            display: flex;
        `};
`;
const StyledInput = styled.input `
    padding: 20px;
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.border};
    width: 100%;
    box-sizing: border-box;
    outline: none;
    font-size: 16px;
    line-height: 1.2rem;
    color: ${(props) => props.theme.textDark};
    border-radius: ${(props) => (props.appTheme === "invoned" ? "8px" : "4px")};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-webkit-input-placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &::-moz-placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &:-ms-input-placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &::placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &:disabled,
    &:read-only {
        background-color: #eeeeee;
        cursor: default;

        + label {
            opacity: 0.5;
        }
    }
`;
const StyledLoader = styled(Loader) `
    position: absolute;
    right: 60px;
    top: 12px;
`;
const InputItem = (_a) => {
    var { className, icon, value, label, placeholder, fullWidth, error, tooltipContents, isMandatory = false, loading = false, hasSearchButton = false, onClick = undefined } = _a, props = __rest(_a, ["className", "icon", "value", "label", "placeholder", "fullWidth", "error", "tooltipContents", "isMandatory", "loading", "hasSearchButton", "onClick"]);
    error = typeof error === "object" ? firstError(error) : error;
    const [id] = useState(_.uniqueId("field-"));
    return (React.createElement(React.Fragment, null,
        React.createElement(InputLabel, { htmlFor: id, isMandatory: isMandatory || props.required, tooltipContents: tooltipContents }, label),
        React.createElement(StyledInputWrapper, { fullWidth: fullWidth, hasSearchButton: hasSearchButton },
            React.createElement(StyledInput, Object.assign({}, props, { id: id, value: value, className: className, placeholder: placeholder, appTheme: getAppThemeName() })),
            loading && React.createElement(StyledLoader, null),
            hasSearchButton && (React.createElement(SearchButton, { disabled: loading, onClick: onClick }))),
        !!error && React.createElement(ErrorLabel, null, _.capitalize(error))));
};
export default InputItem;
